module.exports = __webpack_public_path__ + "static/media/last_cover_page_ma_ko_hun.e1f6db45.png";